export default "__VITE_ASSET__DN$fKApy__"